export default __webpack_public_path__ + "static/media/rmall-project-4.ce55aa4e.png";